import React from 'react'
import Collection from '../common/collection'

function CollectionK({ props }) {
  return (
    <Collection
      src={[
        'https://volverse-negro-daniel.s3.amazonaws.com/images/10.+cerro13.jpg',
      ]}
      alt="Cerro"
    />
  )
}


export default CollectionK
